import { isKeyOf } from '@/shared/utils/isKeyOf.ts';

export interface EnrichedHookFormError {
    field: string;
    message: string;
    scrollToElement: () => void;
}

/** react-hook-form's global error keys, which do not belong to a registered field and cannot be focused. */
type GlobalErrorKey = 'root' | 'form';

const isGlobalErrorKey = (field: string): field is GlobalErrorKey => field === 'root' || field === 'form';

export const enrichHookFormErrorForFulfillmentSectionErrors = <TFieldName extends string>({
    errors,
    setFocus,
}: {
    errors: Partial<Record<TFieldName, { message?: string } | undefined>>;
    setFocus: (fieldName: Exclude<NoInfer<TFieldName>, GlobalErrorKey>) => unknown;
}): EnrichedHookFormError[] => {
    return Object.keys(errors).flatMap(field =>
        isKeyOf(errors, field)
            ? {
                  field,
                  message: errors[field]?.message || '',
                  scrollToElement: () =>
                      !isGlobalErrorKey(field) && field && setFocus(field as Exclude<typeof field, GlobalErrorKey>),
              }
            : []
    );
};
